export const YMM_API_PATH = '/esb/pdesbus21-esb-supplychain-event-processing-info/rest/v1/sc/ymm/'